// extracted by mini-css-extract-plugin
module.exports = {"indretBotoInserir":"Indret_indretBotoInserir__2qgFm","indretSpinner":"Indret_indretSpinner__p8e_x"};